import { Edge } from "../lib/edge";
import { Grid } from "../lib/grid";
import { Node } from "../lib/node";

/**
 * This class represents directed edges.
 */
export class DirectedEdge extends Edge {
    protected nearFactor: number = 0.8;
    
    constructor(from: Node, to: Node) {
        super(from, to);
    }

    /**
     * @param factor: The nearfactor defines the positioning of the arrowhead.
     * 1 is close to the incoming node and 0 is close to the outgoing node. Any value in
     * between are valid
     * 
     * factor range [0,1]
     */
    setNearFactor(factor: number){
        if(factor > 1 || factor <= 0){
            return;
        }
        this.nearFactor = factor;
    }

    
    /**
    * 
    * Draws the directed edge on the canvas
    */
    draw(ctx: CanvasRenderingContext2D, grid: Grid) {
        var centerFrom: [number, number] = this.getCenterFrom(grid);
        var centerTo: [number, number] = this.getCenterTo(grid);;

        if (!this.from.isVisible()) {
            centerFrom = [this.from.getShadowRawX(), this.from.getShadowRawY()];
            ctx.globalAlpha = 0.75;
        }

        if (!this.to.isVisible()) {
            centerTo = [this.to.getShadowRawX(), this.to.getShadowRawY()];
            ctx.globalAlpha = 0.75;
        }
       
        //super.draw(ctx, grid); May restore it


        let correctRaw1: [number, number] = grid.convertCoordinateToRaw(
            this.bezierPoint.point1Coord[0], this.bezierPoint.point1Coord[1]
        );

        let correctRaw2: [number, number] = grid.convertCoordinateToRaw(
            this.bezierPoint.point2Coord[0], this.bezierPoint.point2Coord[1]
        );


        let p0 = [centerFrom[0], centerFrom[1]];
        let p1 = [correctRaw1[0], correctRaw2[1]];
        let p2 = [correctRaw2[0], correctRaw2[1]];
        let p3 = [centerTo[0], centerTo[1]];

        let mid : [number,number] = [(centerFrom[0]+centerTo[0])/2, (centerFrom[1] + centerTo[1])/2]
        let intersection: [number,number] = this.intersection(p2[0], p2[1], p3[0],p3[1], ctx,grid);
        ctx.closePath();
        ctx.save();
        ctx.beginPath();
        ctx.strokeStyle = this.color;
        ctx.fillStyle = this.color;
        ctx.lineWidth = this.lineWidth;
        ctx.moveTo(centerFrom[0],centerFrom[1]);
        if(this.isBezier){
            ctx.bezierCurveTo(p1[0], p1[1],p2[0], p2[1],intersection[0],intersection[1]);
            ctx.stroke();
            this.drawArrowHead(ctx, centerFrom, intersection,
                 [correctRaw1[0], correctRaw2[1]],[correctRaw2[0], correctRaw2[1]], grid);
        }else{
            ctx.lineTo(centerTo[0],centerTo[1]);
            ctx.stroke();
            this.drawArrowHead(ctx, centerFrom, centerTo, mid, mid, grid);
        }
        ctx.closePath();
        ctx.restore();
    }

    getCenterFrom(grid: Grid) : [number,number]{
        return grid.getCellCenter(this.from.getRowIndex(), this.from.getColIndex());
    }
    
    getCenterTo(grid: Grid) : [number,number]{
        return grid.getCellCenter(this.to.getRowIndex(), this.to.getColIndex());        ;
    }

    //Draws the arrowhead
    drawArrowHead(ctx: CanvasRenderingContext2D, from: [number,number],
                 to: [number,number], bezier1:[number,number], bezier2:[number,number], grid:Grid) {
       
        var coord = this.getBezierCoordinates(this.nearFactor, from[0], from[1], bezier1[0], bezier1[1], bezier2[0], bezier2[1], to[0], to[1]);
       // var coord = this.getBezierXY(0.9, 100, 40, 460, 60, 300, 120, 100, 200);
        //var angle = this.getBezierAngle(0.2, 100, 40, 460, 60, 300, 120, 100, 200);
        var angle = this.getBezierAngle(this.nearFactor, from[0], from[1], bezier1[0], bezier1[1], bezier2[0], bezier2[1], to[0], to[1]);


        let sizeA = Math.min(grid.getWidthRadius(), 5);
        ctx.save();
        ctx.beginPath();
        ctx.translate(coord.x, coord.y);
        ctx.rotate(angle);
        ctx.moveTo(-sizeA, -sizeA);
        ctx.lineTo(sizeA, 0);
        ctx.lineTo(-sizeA, sizeA);
        ctx.lineTo(-sizeA, -sizeA);
        ctx.closePath();
        ctx.fill();

        ctx.restore();

    }
}